let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("561TQ")).then(() => parcelRequire('cg7du'));